//src\Components\Header\HeaderUtils.ts
import { setAccounts, setDefaultAccount, setIsAryehAnalyst } from "../../Redux/AccountSlice";
import { setCaseTypes } from "../../Redux/GeneralSlice";
import { setAffiliatesList, setAlalystsList, setSalespersonList, setSellersList } from "../../Redux/UserSlice";
import AccountService from "../../Services/http/AccountService";
import UserService from "../../Services/http/UserService";
import IndexService from "../../Services/http/IndexService";
import userRoles from "../../configs/userRolesConfigs";
import { SessionSorageInstance } from "../../Services/SessionStorageService";

export const GetAccountList = async (dispatch) => {
  const response = await AccountService.getAccounts();
  if (response && response["message"] === "success") {
    dispatch(setAccounts(response["accounts"]));
    const defaultAccount = SessionSorageInstance.getDefaultAccount();
    if (defaultAccount !== null) {
      dispatch(setDefaultAccount(defaultAccount));
    } else {
      dispatch(setDefaultAccount(response["accounts"][0]));
      SessionSorageInstance.setDefaultAccount(response["accounts"][0]);
    }
    CheckIsAryehAnalyst(dispatch);
    return response["accounts"];
  } else {
    return [];
  }
};

export const changeDefaultAccount = (dispatch, defaultAccount) => {
  dispatch(setDefaultAccount(defaultAccount));
};

export const getCaseTypes = async (dispatch) => {
  const response = await IndexService.getCaseTypes();
  if (response && response["message"] === "success") {
    dispatch(setCaseTypes(response["items"]));
  }
};
export const getAnalystList = async (dispatch) => {
  const response = await UserService.getUsersByRolList(userRoles.analyst);
  if (response && response["message"] === "success") {
    dispatch(setAlalystsList(response["items"]));
  }
};
export const getSellersList = async (dispatch) => {
  const response = await UserService.getUsersByRolList(userRoles.account);
  if (response && response["message"] === "success") {
    dispatch(setSellersList(response["items"]));
  }
};

export const getSalespersonList = async (dispatch) => {
  const response = await UserService.getUsersByRolList(userRoles.salesperson);
  if (response && response["message"] === "success") {
    dispatch(setSalespersonList(response["items"]));
  }
};
export const getAffiliateList = async (dispatch) => {
  const response = await UserService.getUsersByRolList(userRoles.affiliate);
  if (response && response["message"] === "success") {
    dispatch(setAffiliatesList(response["items"]));
  }
};

export const getAffiliateListForRegister= () => {
  return async (dispatch) => {
    const response = await UserService.getAffiliatesList();
    if (response && response["message"] === "success") {
      dispatch(setAffiliatesList(response["items"]));
    }
  };
};


export const CheckIsAryehAnalyst = async(dispatch) => {
  const account_id = SessionSorageInstance.getDefaultAccount()['id'];
  const response = await AccountService.checkIsAryehAnalyst(account_id);
  dispatch(setIsAryehAnalyst(response['result']));
};